'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { CHAT_DEFAULT_LOCALE_TEXT } from "./chatLocaleText.js";
import { jsx as _jsx } from "react/jsx-runtime";
const ChatLocaleContext = /*#__PURE__*/React.createContext(CHAT_DEFAULT_LOCALE_TEXT);
if (process.env.NODE_ENV !== "production") ChatLocaleContext.displayName = "ChatLocaleContext";
export function ChatLocaleProvider(props) {
  const {
    children,
    localeText
  } = props;
  const value = React.useMemo(() => _extends({}, CHAT_DEFAULT_LOCALE_TEXT, localeText), [localeText]);
  return /*#__PURE__*/_jsx(ChatLocaleContext.Provider, {
    value: value,
    children: children
  });
}
export function useChatLocaleText() {
  return React.useContext(ChatLocaleContext);
}